import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './team.scss';
import Title from '../../elements/title';
import Image from '../../../components/image';
import { Member, MemberDetails } from './member';
import dataMembers from './members.json';
const Team = () => {
	const member1 = {
		image: 'imageAdrian',
		name: 'Dr. Adrian von Mühlenen',
		bio: 'Ceo',
		linkedin: 'https://www.linkedin.com/in/adrian-von-muehlenen/',
		xing: 'https://www.xing.com/profile/Adrian_vonMuehlenen',
		text:
			'Promovierter Materialwissenschaftler und Diplom Ingenieur Mikrotechnik (ETH Lausanne, Schweiz) mit mehrjähriger Erfahrung in disruptiver Produktinnovation, digitaler Transformation und Organisationsaufbau bei CSEM SA, BASF Schweiz AG und BASF Coatings.',
	};
	const member2 = {
		image: 'imageThomas',
		name: 'Dr. Thomas Janssen',
		bio: 'Product Content',
		linkedin: 'https://www.linkedin.com/in/thomas-janssen-b0196475/',
		xing: 'https://www.xing.com/profile/Thomas_Janssen5/cv',
		text:
			'Promovierter Lebensmittelchemiker mit leitenden Positionen bei Budenheim KG & BASF Coatings. Ehemals Leiter IP Konsortium (REACh), Leiter Fachgrupppe Internationaler Handel beim ELC (FI Europe) und Vertreter des Verbands Codex Alimentarius.',
	};
	const member3 = {
		image: 'imageAmelie',
		name: 'Amelie Wolfgart',
		bio: 'Growth Architect',
		linkedin: 'https://www.linkedin.com/in/ameliewolfgart/',
		xing: 'https://www.xing.com/profile/Amelie_Wolfgart',
		text:
			'M.Sc. in Wirtschaftswissenschaften mit vorherigen Positionen im Bereich Digitalberatung & bei der Bayer AG. Passionierte Entrepreneurin, Startup Förderin und VC Botschafterin.',
	};
	return (
		<section id='team' className='section-padding'>
			<Title title='Das Team' />

			{/* <div className='parent'>
				{dataMembers.map((member) => (
					<Member
						count={member.count}
						name={member.name}
						bio={member.bio}
						image={member.image}
					/>
				))}
			</div> */}
			<div className='team-body'>
				<Container>
					<Row className='members'>
						<Col className='member' md={4}>
							<Member image={member1.image} />
							<div className='d-block d-sm-none'>
								<MemberDetails
									name={member1.name}
									bio={member1.bio}
									linkedin={member1.linkedin}
									xing={member1.xing}
									text={member1.text}
								/>
							</div>
						</Col>
						<Col className='member' md={4}>
							<Member image={member2.image} />
							<div className='d-block d-sm-none'>
								<MemberDetails
									name={member2.name}
									bio={member2.bio}
									linkedin={member2.linkedin}
									xing={member2.xing}
									text={member2.text}
								/>
							</div>
						</Col>
						<Col className='member' md={4}>
							<Member image={member3.image} />
							<div className='d-block d-sm-none'>
								<MemberDetails
									name={member3.name}
									bio={member3.bio}
									linkedin={member3.linkedin}
									xing={member3.xing}
									text={member3.text}
								/>
							</div>
						</Col>
					</Row>
					<Row className='d-none d-md-flex'>
						<Col md={4}>
							<MemberDetails
								name={member1.name}
								bio={member1.bio}
								linkedin={member1.linkedin}
								xing={member1.xing}
								text={member1.text}
							/>
						</Col>
						<Col md={4}>
							<MemberDetails
								name={member2.name}
								bio={member2.bio}
								linkedin={member2.linkedin}
								xing={member2.xing}
								text={member2.text}
							/>
						</Col>
						<Col md={4}>
							<MemberDetails
								name={member3.name}
								bio={member3.bio}
								linkedin={member3.linkedin}
								xing={member3.xing}
								text={member3.text}
							/>
						</Col>
					</Row>
				</Container>
			</div>
		</section>
	);
};

export default Team;
